query CardAccount($id: UUID!) {
  cardAccount(id: $id) {
    id
    name
    _isDeletable
    _rowTimestamp
    businessUnitId
    businessUnits {
      name
    }
    documentPoolId
    description
    _isUpdatable
    _isTagsExist
    statusType {
      statusType
    }
    companyCardCompanies {
      cardCompanyId
      _cardCompanyName
      _isManualProcess
    }
    entityTagsByEntityId {
      nodes {
        id
        _isDeletable
        _tagBadgeName
        _tagBadgeColor
        _rowTimestamp
      }
    }
    cardAccountHistoriesByEntityId {
      nodes {
        crudOperation
        tenantUserName
        pointInTimeDate
      }
    }
    cardAccountTransactions(orderBy: TRANSACTION_DATE_DESC) {
      nodes {
        id
        transactionDate
        entryDate
        description
        _entityDocumentId
        transactionType
        amount
        currencyId
        currency {
          isoCode
        }
        statusType {
          statusType
        }
      }
    }
    notesByEntityId {
      nodes {
        noteComment
      }
    }
  }
}
